import styled from "styled-components";

export const TextEditorBox = styled.div`
  display: flex;
  width: 350px;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  border-radius: 5px;
  border: 1px solid var(--primary-dark-200);
  background-color: var(--primary-dark-100);
`;

export const Text = styled.textarea`
  font-weight: 500;
  border-radius: 3px;
  outline: none;
  min-height: 65px;
  max-height: 300px;
  overflow-y: auto;
  resize: none;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  width: 100%;
  padding: 5px;

  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-dark);
  background-color: transparent;
  border: 1px solid var(--primary-dark-200);
`;

export const TextDescription = styled.textarea`
  font-weight: 500;
  border-radius: 3px;
  outline: none;
  min-height: 400px;
  max-height: 400px;
  overflow-y: auto;
  resize: none;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  width: 100%;
  padding: 5px;

  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-dark);
  background-color: transparent;
  border: 1px solid var(--primary-dark-200);
`;

export const Header = styled.div`
  font-weight: 400;
  font-size: var(--fs-sm);
  color: var(--primary-blue-300);
`;
